import i18n from "../../../../../i18n";
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      fixed: true,
    },
    {
      prop: 'lot_name',
      label: i18n.t('common_words.allotment'),
      minWidth: 100,
      fixed: true,
    },
    {
      prop: 'date_save',
      label: i18n.t('common_words.detection_date'),
      minWidth: 100,
      fixed: true,
    },
    {
      prop: 'outbreak',
      label: i18n.t('diseases.outbreaks_number'),
      minWidth: 100,
      fixed: false,
    },
    {
      prop: 'cases',
      label: i18n.t('diseases.cases_quantity'),
      minWidth: 100,
    },

  ];

  return { Table };

};
export default configTable;
